<template>
  <modal
    :value="value"
    max-width="600"
    title="Selecione os locais"
    content-class="modal modal-round login-personalize-local-modal"
    @input="emitInput"
  >
    <app-button
      v-if="!isPartner"
      label="Selecionar locais"
      bordered
      slot="activator"
      @click="openModal"
    >
    </app-button>

    <local-tree-input
      v-model="selectedLocals"
      :item="item"
      :options="options"
    />

    <app-button
      class="btn btn-round btn-primary"
      slot="footer"
      label="Selecionar"
      primary
      @click="saveStyle"
    >
    </app-button>
  </modal>
</template>

<script>
import EventBus from "@packages/event-bus";
import AppButton from "@/components/generic/button/Button";
import LocalTreeInput from "@components/modules/local/tree/input/LocalTreeInput";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    Modal,
    LocalTreeInput,
    AppButton,
  },

  data() {
    return {
      options: [],
      selectedLocals: [],
    };
  },

  props: {
    item: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isPartner() {
      return this.$store.state.users.user.tipo === "PARCEIRO";
    },
  },

  methods: {
    async loadLocalOptions() {
      this.options = await this.$api.core.account.captiveStyle.locals({
        styleId: this.item.id,
      });

      this.removeLastChildren(this.options);
    },
    emitInput(val) {
      this.$emit("input", val);
    },
    openModal() {
      this.emitInput(true);
    },
    closeModal() {
      this.emitInput(false);
    },
    removeLastChildren(locals) {
      for (const local of locals) {
        if (local.children.length > 0) {
          this.removeLastChildren(local.children);
        } else {
          local.children = undefined;
        }
      }

      return locals;
    },
    async saveStyle() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        const newStyle = await this.$api.core.account.captiveStyle.edit({
          styleId: this.item.id,
          data: {
            name: this.item.name,
            isDefault: this.item.isDefault,
            isDefaultGreen: this.item.isDefaultGreen,
            logo: this.item.logo,
            phraseLogin: this.item.phraseLogin,
            registerBackground: this.item.registerBackground,
            registerBackgroundDesktop: this.item.registerBackgroundDesktop,
            localItemFilter: this.selectedLocals,
            registerStyle: JSON.stringify(this.item.registerStyle),
          },
        });

        this.$emit("saved", {
          ...newStyle,
          registerStyle: JSON.parse(newStyle.registerStyle),
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Estilo salvo com sucesso!",
        });

        this.closeModal();
      } catch (error) {
        //
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
  },

  mounted() {
    this.selectedLocals = this.item.localItemFilter;
  },

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped></style>
